import styled from 'styled-components';

export const Container = styled.main`
  width: 100%;
  height: auto;
  min-height: 100vh;
  position: relative;
  padding: 48px 64px;
  background-color: #f2f2f2;
  ${({ isLogin }) =>
    isLogin &&
    `
      padding: 0;
  `}
`;
